import { type FC } from "react"
import { useDropzone } from "react-dropzone"

import { UploadIcon } from "~/components/Icon"

import { recommendedSizes } from "."

const acceptedImageFileTypes = {
	"image/gif": [".gif"],
	"image/jpeg": [".jpg", ".jpeg"],
	"image/png": [".png"],
	"image/webp": [".webp"],
}

type Props = { onImageDrop(file: File): void; recommendedSize?: keyof typeof recommendedSizes; disableSvg: boolean }
const Dropzone: FC<Props> = ({ onImageDrop, recommendedSize, disableSvg }) => {
	const handleImageDrop = async (acceptedFiles: File[]) => {
		const file = acceptedFiles?.[0]
		if (file === undefined) return

		onImageDrop(file)
	}

	const imageDropzone = useDropzone({
		onDrop: handleImageDrop,
		multiple: false,
		accept: disableSvg ? acceptedImageFileTypes : { ...acceptedImageFileTypes, "image/svg+xml": [".svg"] },
	})

	return (
		<div
			className="flex h-32 cursor-pointer flex-col items-center justify-center gap-3 rounded-lg border border-[#efefef] bg-[#f9f8ff] p-8"
			{...imageDropzone.getRootProps()}
		>
			<input {...imageDropzone.getInputProps()} />
			{!imageDropzone.isDragActive ? (
				<>
					<div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full border-6 border-[#f6f3ff] bg-[#edebf3]">
						<UploadIcon className="text-primary h-6 w-6" />
					</div>
					<p className="text-light text-sm">
						<span className="text-primary font-semibold">Click to upload</span> or drag and drop
					</p>
					{disableSvg && <p className="text-light text-xs">PNG, JPEG, GIF or WebP</p>}
					{imageDropzone.fileRejections.length > 0 && (
						<p className="text-danger text-xs">That file type is not supported</p>
					)}
					{recommendedSize && (
						<p className="text-light text-xs">Recommended size: {recommendedSizes[recommendedSize]}</p>
					)}
				</>
			) : !imageDropzone.isDragReject ? (
				<p className="text-light text-sm">
					<span className="text-primary font-semibold">Drop file</span> to upload
				</p>
			) : (
				<p className="text-light text-sm">
					<span className="text-danger font-semibold">That file type</span> is not supported
				</p>
			)}
		</div>
	)
}

export default Dropzone
